import React, { useState } from 'react'

import { useSelector, useDispatch } from 'react-redux'

import { withRouter } from 'react-router-dom'
import { logout } from '../../../redux/actions/auth'
import { Filters } from '../tools'

import {
  List, ListItem, ListItemIcon, ListItemText, Chip, makeStyles,
  AppBar, Toolbar, Typography, Grid, Breadcrumbs, Avatar,
  Accordion, AccordionSummary, AccordionDetails, IconButton
} from '@material-ui/core'

import { withStyles, emphasize } from '@material-ui/core/styles'

import {
  AccountCircle as AccountCircleIcon, ExitToApp as ExitToAppIcon,
  Domain as DomainIcon, Assessment, PhotoCamera as PhotoCameraIcon, Menu as MenuIcon
} from '@material-ui/icons'

import {
  setPageView, setStatusSnack, setAllChecked, setPageType
} from '../../../redux/actions/select'

import queryString from 'query-string'

import { formatStatusClass, getViolationIndex } from '../../../utils'

const Breadcrumb = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(4),
    color: theme.palette.grey[800],
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[300]
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12)
    }
  }
}))(Chip)

const logo = require('../../../assets/images/logo5.png')

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 300
  },
  listItem: {
    color: '#5291fc',
    paddingTop: 0,
    paddingBottom: 0
  },
  listText: {
    fontWeight: 'bold'
  },
  listSubText: {
    overflow: 'auto',
    color: '#777777',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  listHeaderText: {
    overflow: 'auto',
    color: '#5291fc',
    fontSize: '18px',
    fontWeight: 'bold',
    paddingLeft: '10px'
  },
  chipColor: {
    backgroundColor: '#F44336',
    color: '#f5f5f5',
    height: '19px'
  },
  darkNav: {
    backgroundColor: '#313438',
    opacity: 1,
    zIndex: 1000,
    maxHeight: '7em',
    minHeight: '7em'
  },
  learnsafeLogo: {
    width: '120%',
    height: 'auto',
    margin: 'auto 0',
    backgroundSize: 'contain'
  },
  separator: {
    color: theme.palette.background.paper,
    fontWeight: theme.typography.fontWeightBold
  },
  activeCrumb: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#6CB7FF'
    }
  },
  activeIcon: {
    color: '#fff'
  },
  logoContainer: {
    marginTop: 'auto',
    marginBottom: 'auto',
    paddingTop: 0,
    paddingBottom: 0
  },
  filterContainer: {
    padding: `${theme.spacing(2, 1)} !important`,
    maxHeight: '7em'
  },
  navAvatar: {

  },
  userCard: {
    height: '100%',
    backgroundColor: '#5a6268',
    color: '#fff'
  },
  actionButton: {
    color: '#fff'
  },
  greenActionButton: {
    color: '#A4D164'
  },
  blueActionButton: {
    color: '#3984f7'
  },
  redActionButton: {
    color: theme.palette.error.main
  },
  inactiveList: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: 0
  },
  notificationPopper: {
    zIndex: 1001
  },
  notificationAvatar: {
    backgroundColor: '#A4D164',
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  notificationHeader: {
    paddingBottom: 0
  },
  notificationDivider: {
    height: '0.125em',
    backgroundColor: '#A4D164',
    marginTop: theme.spacing(1),
    width: '100%'
  },
  crumbContainer: {
    maxHeight: '7em'
  },
  navContainer: {
    margin: 'auto',
    height: '100%',
    maxHeight: '7em'
  },
  userContainer: {
    maxHeight: '7em',
    padding: `${theme.spacing(2, 1)} !important`
  },
  accordionSummary: {
    margin: 0,
    '&.Mui-expanded': {
      margin: theme.spacing(1, 0)
    }
  },
  accordionDetails: {
    backgroundColor: '#747C82'
  },
  menuButton: {
    fontSize: '1em',
    fontWeight: 600
  }
}))

const NavbarComponent = (props) => {
  const {
    handleSchoolsToggle, handleSettingsToggle, SelectedStatus,
    setSelectedStatus, currentView, fromLink
  } = { ...props }
  const classes = useStyles()
  const dispatch = useDispatch()
  const parsedProps = queryString.parse(props.location.search)

  const currentPath = props.location.pathname.replace(/\//g, '')
  const Captures = useSelector(state => state.violations.violations.captures)
  const CaptureNum = parseInt(parsedProps.capture, 10)
  const DefaultView = useSelector(state => state.userSettings.general.defaultView)

  const Page = useSelector(state => state.selection.Page)
  const PageCaptureLimit = useSelector(state => state.selection.PageCaptureLimit)

  const currentCapture = currentView === 'single' && Captures.length && parsedProps.capture ? Captures[parseInt(parsedProps.capture, 10) - 1] : []

  const user = useSelector(state => state.auth)
  const userAvatar = useSelector(state => state.userSettings.general.avatarPath)
  // temporary:
  // const notificationsArray = useSelector(state => state.notifications.notifications)

  // const [isOpen, setIsOpen] = useState(false)
  const [drawerOpen, setDrawerOpen] = useState(false)
  // const [notificationAnchor, setNotificationAnchor] = useState(null)

  // const toggle = () => setIsOpen(!isOpen)

  // const handleDrawerToggle = () => {
  //   setDrawerOpen((prev) => !prev)
  // }

  const logOut = (e) => {
    e.stopPropagation()
    e.preventDefault()
    dispatch(logout())
  }

  const setDashboard = () => {
    if (currentCapture.statusFlag === 'U') {
      dispatch(setStatusSnack(true))
      dispatch(setPageType('dashboard'))
    } else {
      dispatch(setPageView('D'))
      props.history.push('/dashboard')
    }
  }

  const setCaptures = async () => {
    if (currentView !== 'single') {
      dispatch(setAllChecked(false))
      if (DefaultView === 'L') {
        props.history.push({
          pathname: '/captures',
          search: '?view=list&page=1&activeCapture=0'
        })
      } else if (DefaultView === 'G') {
        props.history.push({
          pathname: '/captures',
          search: '?view=grid&page=1&activeCaptures=[]'
        })
      } else if (DefaultView === 'D') {
        props.history.push({
          pathname: '/captures',
          search: '?view=single&capture=1'
        })
      }
    } else {
      const captureIx = getViolationIndex({ captureNum: CaptureNum, pageLimit: PageCaptureLimit, page: Page, currentView })
      if (typeof captureIx === 'number' && formatStatusClass(Captures[captureIx].statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
        dispatch(setPageType('captures'))
      } else {
        dispatch(setStatusSnack(false))
        dispatch(setPageType(null))
        if (DefaultView === 'L') {
          props.history.push({
            pathname: '/captures',
            search: '?view=list&page=1&activeCapture=0'
          })
        } else if (DefaultView === 'G') {
          props.history.push({
            pathname: '/captures',
            search: '?view=grid&page=1&activeCaptures=[]'
          })
        } else if (DefaultView === 'D') {
          props.history.push({
            pathname: '/captures',
            search: '?view=single&capture=1'
          })
        }
      }
    }
  }

  // Grab notifications on first load, then on a timer
  // TODO: comment back in when notifications are connected again to the api
  // useEffect(() => {
  //   dispatch(getNotifications())
  //   const interval = setInterval(() => { dispatch(getNotifications()) }, 10000)
  //   return () => clearInterval(interval)
  // }, [dispatch])

  return (
    <>
      <AppBar variant='elevation' position='relative' className={classes.darkNav}>
        <Toolbar className='my-auto'>
          <Grid container direction='row' spacing={2} className={classes.navContainer}>
            <Grid item xs={2} container direction='row' className={classes.logoContainer}>
              <Grid item xs={8}>
                <Avatar src={logo} alt='Logo' className={classes.learnsafeLogo} variant='rounded' />
              </Grid>
            </Grid>

            <Grid item xs={3} container direction='row' alignItems='center' justify='flex-end'>
              <Breadcrumbs separator={<Typography variant='h4' className={classes.separator}>/</Typography>}>
                <Breadcrumb
                  icon={<Assessment className={currentPath === 'dashboard' ? classes.activeIcon : ''} />}
                  label='Dashboard'
                  onClick={() => setDashboard()}
                  className={currentPath === 'dashboard' ? classes.activeCrumb : ''}
                />
                <Breadcrumb
                  icon={<PhotoCameraIcon className={currentPath === 'captures' ? classes.activeIcon : ''} />}
                  label='Captures'
                  onClick={() => setCaptures()}
                  className={currentPath === 'captures' ? classes.activeCrumb : ''}
                />
              </Breadcrumbs>
            </Grid>

            <Grid item xs={3} container direction='row' alignItems='center' justify='flex-end' className={classes.filterContainer}>
              <Filters
                currentView={props.currentView}
                SelectedStatus={SelectedStatus}
                setSelectedStatus={setSelectedStatus}
                fromLink={fromLink}
              />
            </Grid>

            <Grid item xs={4} container direction='row' alignItems='center' justify='flex-end' className={classes.userContainer}>
              <Accordion className={classes.userCard} expanded={drawerOpen} onChange={() => setDrawerOpen(!drawerOpen)}>
                <AccordionSummary classes={{ content: classes.accordionSummary }}>
                  <Grid item container direction='row' alignItems='center' spacing={2} className='m-auto w-100'>
                    <Grid item className='px-0'>
                      <IconButton className={classes.actionButton}>
                        <MenuIcon />
                      </IconButton>
                    </Grid>

                    <Grid item>
                      <Typography variant='h6'>Welcome, {user.firstName}</Typography>
                    </Grid>

                    <Grid item className='px-0'>
                      <Avatar src={userAvatar ? `${userAvatar}?${new Date().getTime()}` : ''} className={classes.navAvatar} />
                    </Grid>
                  </Grid>

                </AccordionSummary>

                <AccordionDetails className={classes.accordionDetails}>
                  <List className='w-100 px-4' disablePadding>
                    <ListItem
                      button
                      disableGutters
                      className='py-1'
                      alignItems='center'
                      onClick={() => { handleSettingsToggle(); setDrawerOpen(false) }}
                    >
                      <ListItemIcon className={classes.actionButton}>
                        <AccountCircleIcon />
                      </ListItemIcon>

                      <ListItemText
                        disableTypography
                        primary={
                          <Typography variant='button' className={classes.menuButton}>
                            Profile
                          </Typography>
                        }
                      />
                    </ListItem>

                    {/* <ListItem
                      button
                      disableGutters
                      className='py-1'
                      onClick={(e) => setNotificationAnchor(e.currentTarget)}
                    >
                      <ListItemIcon className={classes.actionButton}>
                        <NotificationsIcon />
                      </ListItemIcon>

                      <ListItemText primary='Notifications' />
                    </ListItem> */}

                    <ListItem
                      button
                      disableGutters
                      className='py-1'
                      onClick={() => { handleSchoolsToggle(); setDrawerOpen(false) }}
                    >
                      <ListItemIcon className={classes.greenActionButton}>
                        <DomainIcon />
                      </ListItemIcon>

                      <ListItemText
                        disableTypography
                        primary={
                          <Typography variant='button' className={classes.menuButton}>
                            My Schools
                          </Typography>
                        }
                      />
                    </ListItem>

                    <ListItem
                      button
                      onClick={logOut}
                      disableGutters
                      className='py-1'
                    >
                      <ListItemIcon className={classes.redActionButton}>
                        <ExitToAppIcon />
                      </ListItemIcon>

                      <ListItemText
                        disableTypography
                        primary={
                          <Typography variant='button' className={classes.menuButton}>
                            Log Out
                          </Typography>
                        }
                      />
                    </ListItem>
                  </List>
                </AccordionDetails>
              </Accordion>

              {/* TO-DO: Implement Notifications */}
              {/* <ClickAwayListener mouseEvent='onMouseDown' onClickAway={() => setNotificationAnchor(null)}>
                        <Popper
                          open={notificationAnchor !== null}
                          placement='left'
                          anchorEl={notificationAnchor}
                          transition
                          className={classes.notificationPopper}
                        >
                          {({ TransitionProps }) => (
                            <Fade {...TransitionProps}>
                              <Card>
                                <CardHeader
                                  title={
                                    <Grid container direction='row'>
                                      <Grid item container direction='column'>
                                        <Grid item container direction='row' alignItems='center' justify='space-between'>
                                          <Grid item>
                                            <Typography variant='button'>Notifications</Typography>
                                          </Grid>

                                          <Grid item>
                                            <Avatar className={classes.notificationAvatar}>1</Avatar>
                                          </Grid>
                                        </Grid>

                                        <Grid item container direction='row'>
                                          <Divider className={classes.notificationDivider} />
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  }
                                  className={classes.notificationHeader}
                                />
                                <CardContent className='pt-0'>
                                  <List>
                                    <ListItem>
                                      <ListItemText primary='New Capture has been shared!' secondary={moment().format('MM/DD/YYY')} />
                                    </ListItem>
                                  </List>
                                </CardContent>

                              </Card>
                            </Fade>
                          )}
                        </Popper>
                      </ClickAwayListener> */}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  )
}

export default withRouter(NavbarComponent)
